<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>案件稽查管理</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="220" :formData="formData" :tableLabel="tableLabel" :isSelection="true"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">
				<template slot="injuryTypeName" slot-scope="scope">
					<span class="link-text">{{ scope.row.injuryTypeName || '-' }}</span>
				</template>
				<template slot="auditStatusName" slot-scope="scope">
					<span class="link-text">{{ scope.row.auditStatusName || '-' }}</span>
				</template>
				<template slot="auditResultName" slot-scope="scope">
					<span class="link-text">{{ scope.row.auditResultName || '-' }}</span>
				</template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
								<el-button plain type="primary" icon="el-icon-download" :loading="importLoading">导出数据</el-button>
						</div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleAuditProcess(scope.row)" size="small" type="text">稽核处理</el-button>
					<el-button @click="handleView(scope.row)" size="small" type="text">查看详情</el-button>
				</template>
			</myTableSearch>

       </div>

       <!-- 查看详情弹框 -->
       <audit-detail
         :is-dialog="isDetailDialog"
         :detail="detailData"
         @handleClose="handleCloseDetail"
       />

       <!-- 稽核处理弹框 -->
       <audit-handle
         :is-dialog="isHandleDialog"
         :detail="handleDetailData"
         @handleClose="handleCloseHandle"
         @save="handleSaveAudit"
         @submit="handleSubmitAudit"
       />
    </div>
</template>

<script>
import { getSubscribePage, deleteSubscribe, getSubscribeTemplate, importSubscribe } from '@/api/industrialInjury/subscribe'
import { getListByDictType } from '@/api/sys/dictData'
import AuditDetail from './components/auditDetail.vue'
import AuditHandle from './components/handle.vue'

import arrowLeftIcon from '@/assets/pages/appointment/arrow-l.png'
import arrowRightIcon from '@/assets/pages/appointment/arrow-r.png'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import deleteIcon from '@/assets/pages/appointment/delete.png'
import addIcon from '@/assets/pages/appointment/add.png'

export default {
	components: {
		AuditDetail,
		AuditHandle
	},
	data() {
		return {
			arrowLeftIcon,
			isDetailDialog: false,
			detailData: {},
			isHandleDialog: false,
			handleDetailData: {},
			arrowRightIcon,
			refreshIcon,
			deleteIcon,
			addIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑预约弹窗
			isEdit: false,//是否为编辑模式
			editData: {},//编辑时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
				{
					label: '案件编号',
					type: 'input',
					key: 'caseNo',
					colLg: 6,
				},
				{
					label: '伤者姓名',
					type: 'input',
					key: 'injuredName',
					colLg: 6,
				},
				{
					label: '用人单位',
					type: 'input',
					key: 'employer',
					colLg: 6,
				},
				{
					label: '稽核状态',
					type: 'select',
					key: 'auditStatus',
					colLg: 6,
					data: []
				},
				{
					label: '稽核结果',
					type: 'select',
					key: 'auditResult',
					colLg: 6,
					data: []
				},
				{
					label: '稽核日期范围',
					type: 'daterange',
					key: 'auditDateRange',
					colLg: 6,
					screen: (value) => {
						if (value && value.length === 2) {
							return {
								auditDateStart: value[0],
								auditDateEnd: value[1]
							}
						}
						return {}
					}
				},
			],
			tableLabel: [
				{ prop: 'caseNo', label: '案件编号' },
				{ prop: 'injuredName', label: '伤者姓名' },
				{ prop: 'employer', label: '用人单位' },
				{ prop: 'injuryTypeName', label: '伤害类型' },
				{ prop: 'conclusion', label: '认定结论' },
				{ prop: 'auditStatusName', label: '稽核状态' },
				{ prop: 'auditResultName', label: '稽核结果' },
				{ prop: 'isRevokeOriginal', label: '是否撤销原结论' },
				{ prop: 'auditCompleteDate', label: '稽核结办日期' },
				{ prop: 'auditor', label: '稽核人' },
			],
		}
	},
	created() {
		this.loadAuditStatusData()
		this.loadAuditResultData()
	},
	methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getSubscribePage(queryParams)
		},
		// 获取稽核状态字典（默认选项为全部）
		async loadAuditStatusData() {
			const res = await getListByDictType('industrial_injury_audit_status')
			if (res && res.code === 200 && res.data) {
				res.data.unshift({
					dictLabel: '全部',
					dictValue: ''
				})
				this.updateFormDataByKey('auditStatus', res.data)
			}
		},
		// 获取稽核结果字典（默认选项为全部）
		async loadAuditResultData() {
			const res = await getListByDictType('industrial_injury_audit_result')
			if (res && res.code === 200 && res.data) {
				res.data.unshift({
					dictLabel: '全部',
					dictValue: ''
				})
				this.updateFormDataByKey('auditResult', res.data)
			}
		},
		// 更新表单项下拉选项
		updateFormDataByKey(key, data) {
			if (!data) return
			const index = this.formData.findIndex(item => item.key === key)
			if (index !== -1) {
				this.$set(this.formData[index], 'data', data)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},


        // 案件导出
        handleExportCase() {
            // this.exportCaseLoading = true
            // exportCase().then(res => {
            //     if (res && res.code === 200) {
            //         this.exportCaseResultData = res.data
            //         this.isExportCaseDialog = true
            //     }
            // }).finally(() => {
            //     this.exportCaseLoading = false
            // })
        },
        // 查看详情
        handleView(row) {
          this.detailData = { ...row }
          this.isDetailDialog = true
        },
        handleCloseDetail() {
          this.isDetailDialog = false
          this.detailData = {}
        },
        // 稽核处理
        handleAuditProcess(row) {
            this.handleDetailData = { ...row }
            this.isHandleDialog = true
        },
        handleCloseHandle() {
            this.isHandleDialog = false
            this.handleDetailData = {}
        },
        handleSaveAudit(data) {
            console.log('保存稽核', data)
            this.$message.success('保存成功')
            this.handleCloseHandle()
            this.handleRefresh()
        },
        handleSubmitAudit(data) {
            console.log('提交稽核', data)
            this.$message.success('提交成功')
            this.handleCloseHandle()
            this.handleRefresh()
        },

		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
	},
}
</script>


<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: var(--vt-c-blue);
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
</style>